import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withTranslation} from 'react-i18next';
import { submit } from 'redux-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import VirtualLockForm from './VirtualLockForm';

const NewVirtualLockDialog = ({ open, onSubmit, onCancel, submitting, dispatch, t }) => (
  <Dialog open={open} fullWidth={true} onClose={onCancel}>
    <DialogTitle>{t('virtualLocks.newLockDialog.title')}</DialogTitle>
    <DialogContent>
      <VirtualLockForm onSubmit={onSubmit} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} disabled={submitting}>
        {t('common.cancelButton')}
      </Button>
      <Button
        disabled={submitting}
        color="primary"
        variant="contained"
        onClick={() => dispatch(submit('virtualLockForm'))}
      >
        {t('virtualLocks.newLockDialog.submitButton')}
      </Button>
    </DialogActions>
  </Dialog>
);

NewVirtualLockDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default compose(
  connect(),
  withTranslation()
)(NewVirtualLockDialog);
